export interface IUserRoles {
  value: string
  label: string
}

export const USER_ROLES = [
  {
    value: 'executor',
    label: 'Executor',
  },
  {
    value: 'accountant',
    label: 'Accountant',
  },
  {
    value: 'viewer',
    label: 'Viewer',
  },
]

export const DASHBOARD_USER_ROLES = [
  {
    value: 'admin',
    label: 'Admin',
  },
  {
    value: 'executor',
    label: 'Executor',
  },
  {
    value: 'accountant',
    label: 'Accountant',
  },
  {
    value: 'viewer',
    label: 'Viewer',
  },
]
